import { Navigate, Outlet, useLocation } from "react-router-dom";
import checkPermission from "constants/permission";
import routes from "constants/routes";
import { getUserType } from "util/auth";

/**
 * A wrapper for routes that require a specific role.
 * Redirects to the unauthorized page if the user does not have the required role.
 * Token checking and refresh is handled automatically by ApiClient before each API call.
 * @param {object} props - The component props.
 * @param {string[]} props.allowedRoles - The roles allowed to access the route.
 * @returns {Element} The rendered component.
 */
function RoleBasedRoute({ path }: { path: string }) {
  const location = useLocation();
  const checkAuth = Boolean(getUserType());

  if (location.pathname === routes.invalidRoute) return <Outlet />;

  if (!checkAuth) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (!checkPermission(path)) {
    return <Navigate to="/forbidden" />;
  }

  if (location.pathname.includes("YHBB-") && location.pathname.length > 28) {
    const quotationId = location.pathname.slice(28);
    return <Navigate to={`/quotation/${quotationId}`} />;
  }

  return <Outlet />;
}

export default RoleBasedRoute;
